var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJaJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h900v600H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#bc002d",
    cx: 450,
    cy: 300,
    r: 180
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaJp);
export default __webpack_public_path__ + "static/media/ja-JP.e5d06661e02098d998655f18a9271c9a.svg";
export { ForwardRef as ReactComponent };